import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRetrievePlayersByTeamId, useRetrieveTeam, useRetrieveUserTeamPermissions, useUpdatePlayerMembership, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { playerDisplayName } from "../players/PlayerDisplayNameLink";
import { findPlayerById } from "../players/utils";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { FormActions } from "../utils/FormActions";
import { useNumericParams } from "../utils/useNumericParams";
export const EditMembership = () => {
    const { id, playerId } = useNumericParams();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const { data: permissions, isLoading: permsLoading, error: permsError, } = useRetrieveUserTeamPermissions({ teamId: id });
    const { canModify = false } = permissions || {};
    const { data: team, isLoading: teamLoading, error: teamError, } = useRetrieveTeam({ id, enabled: canModify });
    const { data: players, isLoading: playersLoading, error: playersError, } = useRetrievePlayersByTeamId({ teamId: id, enabled: canModify });
    const player = players ? findPlayerById(players)(playerId) : undefined;
    const updateMembershipMutation = useUpdatePlayerMembership({
        teamId: id,
        onSuccess: () => {
            navigate(`/teams/${id}/squad`);
        },
        onError: () => {
            setErrorMessage("Failed to update membership.");
        },
    });
    const { control, handleSubmit } = useForm({
        values: player
            ? {
                squadNumber: player.squadNumber ?? null,
            }
            : { squadNumber: null },
    });
    const onSubmit = (data) => {
        if (!player)
            return;
        updateMembershipMutation.mutate({
            playerId: player.id,
            squadNumber: data.squadNumber ?? null,
        });
    };
    if (permsLoading || teamLoading || playersLoading) {
        return _jsx(Loading, {});
    }
    if (permsError || teamError || playersError) {
        return (_jsx(ErrorView, { error: permsError ||
                teamError ||
                playersError ||
                new Error("Failed to load.") }));
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (!player || !team) {
        return _jsx(NotFound, {});
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!errorMessage, message: errorMessage, onClose: () => setErrorMessage("") }), _jsx(Typography, { variant: "h4", sx: { mb: 1 }, children: "Edit Membership" }), _jsxs(Typography, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: ["Update team membership for ", playerDisplayName(player), " on ", team.name, "."] }), _jsxs(Box, { component: "form", role: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, sx: { maxWidth: 400 }, children: [_jsx(Controller, { name: "squadNumber", control: control, render: ({ field: { value, onChange, ...rest } }) => (_jsx(TextField, { ...rest, value: value ?? "", onChange: (e) => {
                                const raw = e.target.value.trim();
                                onChange(raw === "" ? null : parseInt(raw, 10));
                            }, autoFocus: true, label: "Squad Number", type: "number", fullWidth: true, margin: "normal", inputProps: { min: 1, max: 99 }, helperText: "1\u201399, or leave empty to clear" })) }), _jsx(FormActions, { submitLabel: "Save", isSubmitting: updateMembershipMutation.isLoading, onCancel: () => navigate(`/teams/${id}/squad`) })] })] }));
};
